// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__abeGd","h1":"Hero_h1__9v64Q","container":"Hero_container__yz1of","h2":"Hero_h2__kP1C2","mobileBR":"Hero_mobileBR__TAbb6"};